import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {catchError, Observable} from "rxjs";
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  url = environment.base_url;
  httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  };

  private parentFunction: () => void;

  constructor(private http: HttpClient) {
  }

  getUser(username: string): Observable<any> {
    return this.http.get(this.url + '/get-user-byusername/' + username)
      .pipe(
        catchError((error: any) => {
          console.error('Error getting user by username:', error);
          throw error;
        })
      );
  }


  logIn(user: any) {
    return this.http.post(this.url + '/login', {username: user.username, password: user.password});
  }

  public isLoggedIn() {
    return localStorage.getItem('token') !== null;
  }

  public logout() {
    localStorage.removeItem('user_data');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    localStorage.removeItem('user_id');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('popup');
    localStorage.removeItem('expirationTime');
    localStorage.removeItem('password_version');
    
  }

  public getToken() {
    return localStorage.getItem('token');
  }

  demoLoginCalled(func: () => void) {
    this.parentFunction = func;
  }

  callDemoLogin() {
    if (this.parentFunction) {
        this.parentFunction();
    }
  }
}
